console.log("main.js");
var custom = {
  init: function () {
    custom.sliderHome();
    custom.scrollFilter();
    custom.icoWhats();
    custom.sliderTeacher();
    custom.videoIframe();
    custom.countDown();
    custom.sidebarStickitCustom();
    custom.sliderclick();
    custom.sliderCertOne();
    custom.moreBlockAll();
    custom.sliderGallery();
    custom.phoneInput();
    custom.hourReserv();
    custom.mapMarket();
    custom.clickVideo();
    custom.sliderRoute();
    custom.sliderCourse();
    custom.shopProduct();
    custom.tabsCommunity();
    custom.slideRouteCert();
    custom.slideToolOrgEstud();
    custom.sliderTeacherH();
    custom.sliderTop();
    custom.toggleFilter();
    custom.countDownNavNoti();
    custom.addCommentPage();
    custom.filterHandle();
    custom.countEnabledFilters();
    custom.validateCertificate();
  },
  sliderHome: function () {
    if ($(".slider-home").length) {
      $(".slider-home")
        .slick({
          arrows: false,
          dots: true,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 4000,
          fade: true,
          cssEase: "linear",
        })
        .on("setPosition", function (event, slick) {
          slick.$slides.css("height", slick.$slideTrack.height() + "px");
        });
      $(".slider-home").on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
          $(".slider-info").removeClass("aos-init").removeClass("aos-animate");
        },
      );
      $(".slider-home").on(
        "afterChange",
        function (event, slick, currentSlide, nextSlide) {
          AOS.refresh();
        },
      );
    }
  },
  scrollFilter: function () {
    if ($(".scrollbar-inner").length) {
      $(".scrollbar-inner").scrollbar();
    }
  },
  icoWhats: function () {
    if ($("#block-whats").length) {
      var navigationContainer = $("#block-whats"),
        mainNavigation = navigationContainer.find(
          "#cd-main-whats .block-nav-m",
        );
      $(".cd-whats-trigger").on("click", function (e) {
        e.preventDefault();
        $(this).toggleClass("menu-is-open");
        mainNavigation
          .off(
            "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
          )
          .toggleClass("is-visible");
      });
    }
  },
  countDown: function () {
    if ($(".listTiempo").length) {
      $("[data-countdown]").each(function () {
        var $this = $(this);
        var finalDate = $(this).data("countdown");
        var timeZone = $(this).data("timezone");
        var newFinalDateTZ = finalDate;
        if (moment && timeZone) {
          var momentDate = moment.tz(finalDate, timeZone);
          newFinalDateTZ = momentDate.toDate();
        }

        $this.countdown(newFinalDateTZ, function (event) {
          $this = $(this).html(
            event.strftime(
              "" +
                '<div><span class="datos-tiempo">%D</span><em>Días</em></div><span>:</span>' +
                '<div><span class="datos-tiempo">%H</span><em>Horas</em></div><span>:</span>' +
                '<div><span class="datos-tiempo">%M</span><em>Min</em></div><span>:</span>' +
                '<div><span class="datos-tiempo">%S</span><em>Seg</em></div>',
            ),
          );
        });
      });
    }
  },
  sliderTeacher: function () {
    if ($(".slider-teacher").length) {
      $(".slider-teacher").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
            },
          },
        ],
      });
    }
  },
  sliderRoute: function () {
    if ($(".slider-route-one").length) {
      $(".slider-route-one").slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        arrows: true,
        dots: true,
        infinite: false,
        prevArrow: $(".c-prev-r"),
        nextArrow: $(".c-next-r"),
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
            },
          },
        ],
      });
    }
  },
  slideRouteCert: function () {
    if ($(".slider-route-three").length) {
      $(".slider-route-three").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        arrows: true,
        dots: true,
        infinite: false,
        prevArrow: $(".c-prev-r"),
        nextArrow: $(".c-next-r"),
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
            },
          },
        ],
      });
    }
  },
  slideToolOrgEstud: function () {
    if ($(".slider-tool").length) {
      $(".slider-tool").slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        dots: false,
        infinite: true,
        responsive: [
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: false,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false,
            },
          },
        ],
      });
    }
    if ($(".slider-org").length) {
      $(".slider-org").slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        dots: false,
        infinite: true,
        responsive: [
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: false,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false,
            },
          },
        ],
      });
    }
    if ($(".block-slider-estudent").length) {
      $(".block-slider-estudent").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        dots: true,
        infinite: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
            },
          },
        ],
      });
    }
    if ($(".slider-diplomados").length) {
      $(".slider-diplomados").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        dots: false,
        infinite: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: false,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: false,
            },
          },
        ],
      });
    }
  },
  sliderTeacherH: function () {
    if ($(".slider-teacher-h").length) {
      $(".slider-teacher-h").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        dots: false,
        infinite: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
              dots: true,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots: true,
            },
          },
        ],
      });

      function fixSlickStyle(event, slick) {
        if (slick.slideCount <= slick.options.slidesToShow) {
          slick.$slideTrack.css("transform", "");
        }
      }

      $(".slider-teacher-h")
        .on("setPosition", function (event, slick) {
          fixSlickStyle(event, slick);
        })
        .on("afterChange", function (event, slick, currentSlide) {
          fixSlickStyle(event, slick);
        });
    }
  },
  sliderTop: function () {
    if ($(".block-slider-top").length) {
      /* ═══════════════════════════════════
        SWIPER — loop: true
      ═══════════════════════════════════ */
      ["#swiperTrending", "#swiperTop10"].forEach((sel) => {
        new Swiper(sel, {
          loop: true,
          grabCursor: true,
          breakpoints: {
            0: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 8 },
            575: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 10 },
            768: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 12 },
            992: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 14 },
            1200: { slidesPerView: 5, slidesPerGroup: 5, spaceBetween: 16 },
          },
          navigation: {
            nextEl: `${sel} .swiper-button-next`,
            prevEl: `${sel} .swiper-button-prev`,
          },
        });
      });

      /* ═══════════════════════════════════
        HOVER PREVIEW
        Single visually-hidden div.
        On hover → position over card with
        getBoundingClientRect, expand outward.
      ═══════════════════════════════════ */
      const hp = document.getElementById("hoverPreview");
      const hpBox = hp.querySelector(".hp-box");
      const hpVideo = document.getElementById("hpVideo");
      const hpLink = document.getElementById("hpLink");
      const hpTitle = document.getElementById("hpTitle");
      const hpDur = document.getElementById("hpDuration");
      const hpAudio = document.getElementById("hpAudio");
      const icoM = document.getElementById("icoMuted");
      const icoU = document.getElementById("icoUnmuted");

      let activeCard = null;
      let enterTimer = null;
      let leaveTimer = null;
      let collapseTimer = null;
      let isOpen = false;
      let isMuted = true;
      let lastX = 0,
        lastY = 0;

      const DELAY_OPEN = 400;
      const DELAY_CLOSE = 200;
      const EXPAND_EXTRA = 60; // px wider than card on each side

      const canHover = () =>
        window.matchMedia("(hover: hover) and (min-width: 769px)").matches;
      const findCard = (el) =>
        el?.closest(".card-link") || el?.closest(".top10-link");

      /* ── Position preview centered on card, like Netflix ── */
      function positionOverCard(card) {
        const rect = card.getBoundingClientRect();

        // Preview width = card + expand on each side
        const previewW = rect.width + EXPAND_EXTRA * 2;

        // Estimate preview height: video (16:9 of previewW) + info bar (~70px)
        const videoH = (previewW * 9) / 16;
        const previewH = videoH + 70;

        // Center horizontally on card center
        let left = rect.left + rect.width / 2 - previewW / 2;

        // Center vertically on card center
        let top = rect.top + rect.height / 2 - previewH / 2;

        // Clamp to viewport edges
        const m = 6;
        if (left < m) left = m;
        if (left + previewW > window.innerWidth - m)
          left = window.innerWidth - previewW - m;
        if (top < m) top = m;
        if (top + previewH > window.innerHeight - m)
          top = window.innerHeight - previewH - m;

        hp.style.position = "fixed";
        hp.style.left = left + "px";
        hp.style.top = top + "px";
        hp.style.width = previewW + "px";
      }

      /* ── Open ── */
      function openPreview(card) {
        if (activeCard === card && isOpen) return;

        // If switching cards: instant reposition
        if (isOpen && activeCard !== card) {
          clearTimeout(collapseTimer);
          activeCard = card;
          fillData(card);
          positionOverCard(card);
          loadVideo(card);
          return;
        }

        activeCard = card;
        isOpen = true;

        fillData(card);
        positionOverCard(card);

        // Remove collapsing, add active
        hp.classList.remove("collapsing");
        hp.classList.add("active");
        hp.setAttribute("aria-hidden", "false");

        loadVideo(card);
      }

      function fillData(card) {
        hpLink.href = card.dataset.link;
        hpTitle.textContent = card.dataset.title;
        hpDur.textContent = card.dataset.duration;
      }

      /* YouTube no se reproduce en <video>: para esos enlaces se usa un
         iframe embed (silenciado, en bucle) en lugar del <video>. */
      let hpFrame = null;
      function clearFrame() {
        if (hpFrame) {
          hpFrame.remove();
          hpFrame = null;
        }
        hpVideo.style.display = "";
      }

      function loadVideo(card) {
        const ytId = custom.youtubeId(card.dataset.video);
        clearFrame();
        isMuted = true;
        icoM.style.display = "";
        icoU.style.display = "none";
        if (ytId) {
          hpVideo.pause();
          hpVideo.removeAttribute("src");
          hpVideo.load();
          hpVideo.style.display = "none";
          hpFrame = document.createElement("iframe");
          hpFrame.className = "hp-video";
          hpFrame.setAttribute("frameborder", "0");
          hpFrame.setAttribute("allow", "autoplay; encrypted-media; picture-in-picture");
          hpFrame.style.border = "0";
          hpFrame.style.pointerEvents = "none";
          hpFrame.src =
            "https://www.youtube.com/embed/" + ytId +
            "?autoplay=1&mute=1&controls=0&loop=1&playlist=" + ytId +
            "&playsinline=1&rel=0&modestbranding=1&enablejsapi=1";
          hpVideo.parentNode.insertBefore(hpFrame, hpVideo);
          return;
        }
        hpVideo.src = card.dataset.video;
        hpVideo.muted = true;
        hpVideo.play().catch(() => {});
      }

      /* ── Close with animation ── */
      function closePreview() {
        if (!isOpen) return;

        hp.classList.add("collapsing");

        collapseTimer = setTimeout(() => {
          hp.classList.remove("active", "collapsing");
          hp.setAttribute("aria-hidden", "true");
          hpVideo.pause();
          hpVideo.removeAttribute("src");
          hpVideo.load();
          clearFrame();
          activeCard = null;
          isOpen = false;
        }, 220);
      }

      /* ── Instant close (for scroll/resize) ── */
      function closeInstant() {
        clearTimeout(enterTimer);
        clearTimeout(leaveTimer);
        clearTimeout(collapseTimer);
        hp.classList.remove("active", "collapsing");
        hp.setAttribute("aria-hidden", "true");
        hpVideo.pause();
        hpVideo.removeAttribute("src");
        hpVideo.load();
        clearFrame();
        activeCard = null;
        isOpen = false;
      }

      function clearTimers() {
        clearTimeout(enterTimer);
        clearTimeout(leaveTimer);
      }

      /* ── Mouse tracking ── */
      document.addEventListener(
        "pointermove",
        (e) => {
          lastX = e.clientX;
          lastY = e.clientY;
        },
        { passive: true },
      );

      /* ── Card enter ── */
      document.addEventListener(
        "pointerenter",
        (e) => {
          if (!canHover()) return;
          const card = findCard(e.target);
          if (!card) return;
          clearTimers();
          if (activeCard === card && isOpen) return;

          // If already open on another card → switch instantly
          const delay = isOpen ? 0 : DELAY_OPEN;
          enterTimer = setTimeout(() => openPreview(card), delay);
        },
        true,
      );

      /* ── Card leave ── */
      document.addEventListener(
        "pointerleave",
        (e) => {
          if (!canHover()) return;
          const card = findCard(e.target);
          if (!card) return;
          clearTimers();

          leaveTimer = setTimeout(() => {
            const el = document.elementFromPoint(lastX, lastY);
            if (el && hp.contains(el)) return; // moved to preview
            if (el && findCard(el)) return; // moved to another card
            closePreview();
          }, DELAY_CLOSE);
        },
        true,
      );

      /* ── Preview enter/leave ── */
      hp.addEventListener("pointerenter", () => clearTimers());
      hp.addEventListener("pointerleave", () => {
        clearTimers();
        leaveTimer = setTimeout(() => {
          const el = document.elementFromPoint(lastX, lastY);
          if (el && findCard(el)) return;
          closePreview();
        }, DELAY_CLOSE);
      });

      /* ── Audio toggle ── */
      hpAudio.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        isMuted = !isMuted;
        if (hpFrame && hpFrame.contentWindow) {
          hpFrame.contentWindow.postMessage(
            JSON.stringify({ event: "command", func: isMuted ? "mute" : "unMute", args: [] }),
            "*",
          );
        } else {
          hpVideo.muted = isMuted;
        }
        icoM.style.display = isMuted ? "" : "none";
        icoU.style.display = isMuted ? "none" : "";
        hpAudio.setAttribute(
          "aria-label",
          isMuted ? "Activar audio" : "Silenciar audio",
        );
      });

      /* ── Close on scroll/resize ── */
      window.addEventListener("scroll", closeInstant, { passive: true });
      window.addEventListener("resize", closeInstant, { passive: true });
    }
  },
  /* Id de un enlace de YouTube (watch?v=, youtu.be/, shorts/, live/, embed/), o null. */
  youtubeId: function (url) {
    if (!url || typeof url !== "string") return null;
    var m = url
      .trim()
      .match(
        /^(?:https?:)?(?:\/\/)?(?:www\.|m\.|music\.)?(?:youtube(?:-nocookie)?\.com|youtu\.be)\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/|v\/|e\/)?([A-Za-z0-9_-]{11})(?:[?&#\/].*)?$/i,
      );
    return m ? m[1] : null;
  },
  /* YouTube rechaza los enlaces "watch" dentro de un iframe: se pasan a /embed/ID.
     Cualquier otra URL se devuelve igual. */
  toEmbedUrl: function (url) {
    var id = custom.youtubeId(url);
    if (!id || /\/embed\//i.test(url)) return url;
    var start = 0;
    var t = /[?&](?:t|start)=([0-9hms]+)/i.exec(url);
    if (t) {
      if (/^\d+$/.test(t[1])) {
        start = parseInt(t[1], 10);
      } else {
        var h = /(\d+)h/.exec(t[1]), mi = /(\d+)m/.exec(t[1]), se = /(\d+)s/.exec(t[1]);
        start = (h ? +h[1] * 3600 : 0) + (mi ? +mi[1] * 60 : 0) + (se ? +se[1] : 0);
      }
    }
    return "https://www.youtube.com/embed/" + id + (start > 0 ? "?start=" + start : "");
  },
  videoIframe: function () {
    $(".item-video").click(function () {
      var htmlVideo = $(this).find(".hidden-video").html();
      var linkSrc = custom.toEmbedUrl($(this).data("video"));
      $("#videoModal").modal("show");
      $("#course-video-content").html(htmlVideo);
      setTimeout(function () {
        $("#course-video-content").find("iframe").attr("src", linkSrc);
      }, 200);
    });
    $("#videoModal").on("hidden.bs.modal", function (event) {
      $("#course-video-content").find("iframe").attr("src", "");
    });
  },
  sidebarStickitCustom: function () {
    if ($(".sidebar-stickit-custom").length) {
      $(".sidebar-stickit-custom").stickit({
        screenMinWidth: 992,
        top: 90,
      });
    }
  },
  sliderclick: function () {
    if ($(".all-slider-list").length) {
      const $featureItems = $(".feature-item");
      const $slider = $("#mainImageSlider");

      // Initialize Slick Slider
      $slider.slick({
        dots: false,
        infinite: true,
        speed: 400,
        fade: true,
        cssEase: "cubic-bezier(0.7, 0, 0.3, 1)",
        autoplay: false,
        arrows: false,
        draggable: true,
        swipe: true,
        touchThreshold: 10,
        adaptiveHeight: false,
      });

      $slider.on("afterChange", function (event, slick, currentSlide) {
        updateActiveState(currentSlide);
      });

      // Function to update active states
      function updateActiveState(slideIndex) {
        // Update feature items highlight
        $featureItems.removeClass("active");
        $featureItems.eq(slideIndex).addClass("active");
      }

      // Click on feature item
      $featureItems.on("click", function () {
        const slideIndex = $(this).index();
        $slider.slick("slickGoTo", slideIndex);
      });

      // Keyboard navigation
      $(document).on("keydown", function (e) {
        if (e.key === "ArrowLeft") {
          $slider.slick("slickPrev");
        } else if (e.key === "ArrowRight") {
          $slider.slick("slickNext");
        }
      });

      // Initialize first slide as active
      updateActiveState(0);
    }
  },
  sliderCourse: function () {
    if ($(".slider-item-c").length) {
      $(".slider-item-c").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        autoplay: true,
        autoplaySpeed: 3500,
        appendDots: $(".b-arrow-ds"),
        arrows: false,
      });
    }
  },
  moreBlockAll: function () {
    $(".all-t-more .moreActive").on("click", function () {
      $(this).parent().find(".b-p").toggleClass("hide-desc");
      $(this).parent().find(".b-p1").slideToggle(0);
      if ($(this).text() == "Ver más") {
        $(this).text("Ver menos");
      } else {
        $(this).text("Ver más");
      }
    });

    $(".t-more-n .moreActive").on("click", function () {
      $(this).parent().find(".b-p1").toggleClass("t-active");
      $(this).parent().find(".b-p1").slideToggle(0);
      if ($(this).hasClass("t-active")) {
        $(this).html('Ocultar resumen <i class="fas fa-chevron-right"></i>');
      } else {
        $(this).html('Ver resumen <i class="fas fa-chevron-right"></i>');
      }
    });
  },
  sliderCertOne: function () {
    if ($(".slider-cert-one").length) {
      $(".slider-cert-one").slick({
        arrows: true,
        prevArrow: $(".c-prev"),
        nextArrow: $(".c-next"),
        dots: true,
        autoplay: false,
        autoplaySpeed: 3000,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  },
  sliderGallery: function () {
    if ($(".inner-gallery-event").length) {
      $(".popup-gallery-lead").magnificPopup({
        delegate: "a",
        type: "image",
        tLoading: "Cargando imagen #%curr%...",
        mainClass: "mfp-img-mobile",
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
        },
        image: {
          tError: "",
          titleSrc: function (item) {
            return item.el.attr("title");
          },
        },
      });
    }
  },
  phoneInput: function () {
    if ($("#inputPhoneNumberRegInf").length) {
      var inputPhoneNumberRegInf = document.querySelector(
        "#inputPhoneNumberRegInf",
      );
      var countryCode = $("#inputPhoneNumberRegInf").data("country");
      if (countryCode == "") {
        countryCode = "pe";
      }
      var intPhoneNumberReg = intlTelInput(inputPhoneNumberRegInf, {
        initialCountry: countryCode,
        //utilsScript: main.host + "dist/js/utils.js",
        utilsScript:
          "https://intl-tel-input.com/node_modules/intl-tel-input/build/js/utils.js?1549804213570",
        preferredCountries: ["pe", "co", "mx", "ar", "es", "us"],
        placeholderNumberType: "MOBILE",
        separateDialCode: true,
      });
    }
  },
  hourReserv: function () {
    if ($(".block-calendar-reserv").length) {
      $("#datepickerMent").datepicker({
        language: "es",
        todayHighlight: true,
      });

      if ($(".footer-calendar-m").length) {
        $(".hour-select").customSelect();
      }
      $(".event-resv").click(function () {
        var eventR = $(this);
        eventR.hide();
        eventR.parent("li").find(".resv-btn").show();
      });
    }
  },
  mapMarket: function () {
    if ($(".map-canvas").length) {
      $(".mapShow").click(function (e) {
        e.preventDefault();
        $(".mapShow").remove();
        $(".map-canvas").addClass("map-show");
        var lat = $(".map-canvas").data("lat");
        var log = $(".map-canvas").data("lon");
        var direc = $(".map-canvas").data("direc");

        var map = new google.maps.Map($(".map-canvas")[0], {
          zoom: 16,
          center: new google.maps.LatLng(lat, log),
        });
        var marker = new google.maps.Marker({
          map: map,
          position: new google.maps.LatLng(lat, log),
        });
        var info = new SnazzyInfoWindow({
          marker: marker,
          closeOnMapClick: false,
          content: direc,
        });
        info.open();
      });
    }
  },
  clickVideo: function () {
    if ($(".video-m").length) {
      $(".video-m").click(function () {
        $(this).hide();
        $(this).siblings(".b-content-video").show();
        $(this).siblings(".b-content-video").addClass("video-concl");
      });
    }
    if ($(".video-iframe-t").length) {
      $(".video-iframe-t").click(function () {
        $(this).hide();
        $(this).siblings(".b-content-video").show();
        $(this).siblings(".b-content-video").addClass("video-concl");
      });
    }
    $("#reserveModal").on("hidden.bs.modal", function (event) {
      $("#block-reserv-c").show();
      $("#listHourCalendar").hide();
      $(".btn-return").hide();
    });
  },
  shopProduct: function () {
    $(".slider-product-image").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: ".slider-product-thumbnail",
    });
    $(".slider-product-thumbnail").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: ".slider-product-image",
      dots: false,
      focusOnSelect: true,
      infinite: false,
      prevArrow: $(".prev-product"),
      nextArrow: $(".next-product"),
    });
  },
  toggleFilter: function () {
    if ($(".inner-filter-result").length) {
      console.log("probando");
      function myFunction(x) {
        if (x.matches) {
          $(".inner-filter-result").removeClass("active-filter");
        } else {
          $("body").removeClass("sidebar-movil-active");
        }
      }

      var x = window.matchMedia("(max-width: 992px)");
      myFunction(x);
      x.addListener(myFunction);

      function handler1() {
        $(".inner-filter-result").addClass("active-filter");
        $(this).one("click", handler2);
      }
      function handler2() {
        $(".inner-filter-result").removeClass("active-filter");
        $(this).one("click", handler1);
      }
      $(".btn-filter").one("click", handler1);

      /*event click Sidebar filter Movil*/
      $(".btn-filter-m").click(function () {
        $("body").addClass("sidebar-movil-active");
      });
      $(".close-sidebar-active").click(function () {
        $("body").removeClass("sidebar-movil-active");
      });
    }
  },
  countDownNavNoti: function () {
    if ($(".listTiempoNavNoti").length) {
      $("[data-countdownnavnoti]").each(function () {
        var $this = $(this);
        var finalDate = $(this).data("countdownnavnoti");
        var timeZone = $(this).data("timezone");
        var newFinalDateTZ = finalDate;
        if (moment && timeZone) {
          var momentDate = moment.tz(finalDate, timeZone);
          newFinalDateTZ = momentDate.toDate();
        }

        $this.countdown(newFinalDateTZ, function (event) {
          $this = $(this).html(
            event.strftime(
              "" +
                '<div><span class="datos-tiempo">%D</span><em>Días</em></div><span>:</span>' +
                '<div><span class="datos-tiempo">%H</span><em>Horas</em></div><span>:</span>' +
                '<div><span class="datos-tiempo">%M</span><em>Min</em></div><span>:</span>' +
                '<div><span class="datos-tiempo">%S</span><em>Seg</em></div>',
            ),
          );
        });
      });
    }
  },
  addCommentPage: function () {
    if ($("#commentModal").length) {
      var myModalComment = document.getElementById("commentModal");
      myModalComment.addEventListener("shown.bs.modal", function (event) {
        console.log("Aparecio el modal");
        $(".eventAddComment").click(function () {
          $.ajax({
            url: "dist/comment.json",
            method: "GET",
            dataType: "json",
            success: function (data) {
              $.each(data, function (i, item) {
                console.log("all");
                var index = parseInt(i);
                index++;
                var templateComment = `<div class="col-md-6">
                  <div class="clear-fix list-answer">
                    <div class="clear-fix item-answer">
                      <figure
                        style="
                          background: url(${item["img"]}) no-repeat;
                          background-size: cover;
                        "
                      >
                        <img src="${item["img"]}" alt="" />
                      </figure>
                      <div class="clear-fix name-start">
                        <h3>${item["name"]}</h3>
                        <div class="start-calf">
                          <i class="fas fa-star"></i>
                          <i class="fas fa-star"></i>
                          <i class="fas fa-star"></i>
                          <i class="fas fa-star-half-alt"></i>
                          <i class="far fa-star"></i>
                        </div>
                        <span>${item["fech"]}</span>
                      </div>
                    </div>
                    <p>${item["desc"]}</p>
                  </div>
                </div>`;
                $("#dataComment").append(templateComment);
              });
            },
            error: function (error) {
              console.error("Error:", error);
            },
          });
        });
      });
    }
  },
  filterHandle: function () {
    var urlParams = new URLSearchParams(window.location.search);
    var splitHref = window.location.href.split("?");

    $('.sidebar-filter .all-form-filter input[type="checkbox"]').click(
      function (e) {
        var key = e.target.value.split("_")[0] + "[]";
        var value = e.target.value.split("_")[1];
        if (e.target.checked) {
          if (urlParams.has(key)) {
            if (urlParams.getAll(key).indexOf(value) < 0) {
              urlParams.append(key, value);
            }
          } else {
            urlParams.append(key, value);
          }
        } else {
          if (urlParams.has(key)) {
            var values = urlParams.getAll(key);
            if (values.indexOf(value) > -1) {
              values.splice(values.indexOf(value), 1);
              urlParams.delete(key);

              values.forEach(function (value1) {
                urlParams.append(key, value1);
              });
            }
          }
        }

        var newHref = splitHref[0] + "?" + urlParams.toString();
        custom.saveOrDoFilter(newHref);
      },
    );
  },
  countEnabledFilters: function () {
    var countEnabledFilter = 0;
    $('.sidebar-filter .all-form-filter input[type="checkbox"]').each(
      function (e) {
        if ($(this).attr("checked")) {
          countEnabledFilter++;
        }
      },
    );

    var countEnabledFilterText = "";
    if (countEnabledFilter > 0) {
      countEnabledFilterText = "(" + countEnabledFilter + ")";
    }

    $(".count-filter").text(countEnabledFilterText);
  },
  saveOrDoFilter: function (newHref) {
    if (custom.isMobile()) {
      localStorage.setItem("filterHref", newHref);
    } else {
      location.href = newHref;
    }
  },
  isMobile: function () {
    var isMobile = false;
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      )
    ) {
      isMobile = true;
    }
    return isMobile;
  },
  validateCertificate: function () {
    if ($("#form-validate-certificate").length) {
      $("#form-validate-certificate").validate({
        // Specify the validation rules
        rules: {
          code: { required: true },
        },
        // Specify the validation error messages
        messages: {
          code: { required: "Escribe un código valido." },
        },
        errorPlacement: function (error, element) {
          error.insertBefore(
            $(element)
              .parents(".cnt-content-list-e")
              .find(".error-cnt")
              .html(error),
          );
        },
        highlight: function (element) {
          $(element).parent("div").addClass("error-n");
        },
        unhighlight: function (element) {
          $(element).parent("div").removeClass("error-n");
        },
        submitHandler: function (form) {
          $("#form-validate-certificate")
            .find(".btn-l-primary")
            .addClass("block-btn-load");
          var params = $("#form-validate-certificate").serialize();

          $.ajax({
            url: main.getUri("/page/save-certificate"),
            data: params,
            type: "POST",
            dataType: "json",
            beforeSend: function (xhr) {
              xhr.overrideMimeType("text/plain; charset=x-user-defined");
            },
            success: function (data) {
              $("#form-validate-certificate")
                .find(".btn-l-primary")
                .removeClass("block-btn-load");
              var strLocal = "";
              if (data.success == true) {
                data.data.forEach((value, indice) => {
                  strLocal +=
                    '<li><a href="' +
                    value.url +
                    '" target="_blank">' +
                    value.name +
                    "</a></li>";
                });
              } else {
                strLocal = "<li>Certificado invalido</li>";
              }
              $("#idResponse").html(strLocal);
            },
            error: function (xhr, status) {},
          });
          return false;
        },
      });
    }
  },
  tabsCommunity: function () {
    if ($(".block-tab-community").length) {
      // ── Seeded Random ──
      function seededRandom(seed) {
        let s = seed;
        return function () {
          s = (s * 16807) % 2147483647;
          return s / 2147483647;
        };
      }

      // ── Render Instructors Grid (scattered circular layout) ──
      function renderInstructorsGrid() {
        const grid = document.getElementById("instructoresGrid");
        const profile = document.getElementById("instructorProfile");
        grid.style.display = "block";
        profile.style.display = "none";

        const rng = seededRandom(42);
        const avatarSize = 68;
        const containerSize = 1000;
        const cx = containerSize / 2;
        const cy = containerSize / 2;
        const radiusX = containerSize * 0.46;
        const radiusY = containerSize * 0.46;
        const minDist = avatarSize + 14;
        const positions = [];

        for (let i = 0; i < instructors.length; i++) {
          let placed = false,
            attempts = 0;
          while (!placed && attempts < 2000) {
            const angle = rng() * Math.PI * 2;
            const dist = Math.sqrt(rng()) * 0.88;
            const px = cx + Math.cos(angle) * dist * radiusX - avatarSize / 2;
            const py = cy + Math.sin(angle) * dist * radiusY - avatarSize / 2;
            if (
              px < 2 ||
              py < 2 ||
              px + avatarSize > containerSize - 2 ||
              py + avatarSize > containerSize - 2
            ) {
              attempts++;
              continue;
            }
            let collides = false;
            const centerX = px + avatarSize / 2,
              centerY = py + avatarSize / 2;
            for (const pos of positions) {
              const dx = centerX - (pos.x + avatarSize / 2),
                dy = centerY - (pos.y + avatarSize / 2);
              if (Math.sqrt(dx * dx + dy * dy) < minDist) {
                collides = true;
                break;
              }
            }
            if (!collides) {
              positions.push({ x: px, y: py });
              placed = true;
            }
            attempts++;
          }
          if (!placed) {
            const cols = Math.ceil(Math.sqrt(instructors.length));
            const fx = (positions.length % cols) * (avatarSize + 10) + 20;
            const fy =
              Math.floor(positions.length / cols) * (avatarSize + 10) + 20;
            positions.push({ x: fx, y: fy });
          }
        }

        let html = "";
        positions.forEach((pos, i) => {
          const inst = instructors[i];
          const rot = (rng() - 0.5) * 4;
          html += `
        <div class="instructor-avatar" data-id="${inst.id}"
            style="left:${((pos.x / containerSize) * 100).toFixed(2)}%; top:${((pos.y / containerSize) * 100).toFixed(2)}%; animation: fadeIn 0.4s ease ${i * 0.03}s both; transform: rotate(${rot.toFixed(1)}deg);">
          <div class="avatar-img">
            <img src="${inst.avatar}" alt="${inst.name}" loading="lazy">
          </div>
          <span class="instructor-flag">${inst.country}</span>
        </div>`;
        });
        grid.innerHTML = html;
      }

      // ── Render Collaborators Grid (scattered circular layout) ──

      function renderCollaboratorsGrid() {
        const grid = document.getElementById("collaboratorsGrid");
        const profile = document.getElementById("collaboratorsProfile");
        grid.style.display = "block";
        profile.style.display = "none";

        const rng = seededRandom(42);
        const avatarSize = 68;
        const containerSize = 1000;
        const cx = containerSize / 2;
        const cy = containerSize / 2;
        const radiusX = containerSize * 0.46;
        const radiusY = containerSize * 0.46;
        const minDist = avatarSize + 14;
        const positions = [];

        for (let i = 0; i < collaborators.length; i++) {
          let placed = false,
            attempts = 0;
          while (!placed && attempts < 2000) {
            const angle = rng() * Math.PI * 2;
            const dist = Math.sqrt(rng()) * 0.88;
            const px = cx + Math.cos(angle) * dist * radiusX - avatarSize / 2;
            const py = cy + Math.sin(angle) * dist * radiusY - avatarSize / 2;
            if (
              px < 2 ||
              py < 2 ||
              px + avatarSize > containerSize - 2 ||
              py + avatarSize > containerSize - 2
            ) {
              attempts++;
              continue;
            }
            let collides = false;
            const centerX = px + avatarSize / 2,
              centerY = py + avatarSize / 2;
            for (const pos of positions) {
              const dx = centerX - (pos.x + avatarSize / 2),
                dy = centerY - (pos.y + avatarSize / 2);
              if (Math.sqrt(dx * dx + dy * dy) < minDist) {
                collides = true;
                break;
              }
            }
            if (!collides) {
              positions.push({ x: px, y: py });
              placed = true;
            }
            attempts++;
          }
          if (!placed) {
            const cols = Math.ceil(Math.sqrt(collaborators.length));
            const fx = (positions.length % cols) * (avatarSize + 10) + 20;
            const fy =
              Math.floor(positions.length / cols) * (avatarSize + 10) + 20;
            positions.push({ x: fx, y: fy });
          }
        }

        let html = "";
        positions.forEach((pos, i) => {
          const inst = collaborators[i];
          const rot = (rng() - 0.5) * 4;
          html += `
        <div class="instructor-avatar" data-id="${inst.id}"
            style="left:${((pos.x / containerSize) * 100).toFixed(2)}%; top:${((pos.y / containerSize) * 100).toFixed(2)}%; animation: fadeIn 0.4s ease ${i * 0.03}s both; transform: rotate(${rot.toFixed(1)}deg);">
          <div class="avatar-img">
            <img src="${inst.avatar}" alt="${inst.name}" loading="lazy">
          </div>
          <span class="instructor-flag">${inst.country}</span>
        </div>`;
        });
        grid.innerHTML = html;
      }

      function showCollaborators(id) {
        const inst = collaborators.find((i) => i.id === id);
        if (!inst) return;
        const grid = document.getElementById("collaboratorsGrid");
        const profile = document.getElementById("collaboratorsProfile");
        grid.style.display = "none";
        profile.style.display = "block";
        profile.style.animation = "none";
        profile.offsetHeight;
        profile.style.animation = "fadeSlideUp 0.5s ease";
        profile.innerHTML = `
          <button class="profile-back-btn" id="collaboratorsBackBtn"><i class="fa-solid fa-chevron-left"></i> Volver</button>
          <img src="${inst.avatar}" alt="${inst.name}" class="profile-avatar-lg">
          <div class="profile-name">${inst.name}</div>
          <div class="profile-expertise">${inst.expertise}</div>
          <div class="profile-bio-card">
            <h4>Biografía resumida</h4>
            <p>${inst.bio}</p>
            <h4 style="margin-top:1.2rem;">Biografía Completa</h4>
            <p>${inst.bioFull}</p>
            <div class="profile-social">
            <a href="#"><i class="fa-brands fa-instagram"></i></a>
            <a href="#"><i class="fa-brands fa-linkedin-in"></i></a>
            <a href="#"><i class="fa-brands fa-x-twitter"></i></a>
            <a href="#"><i class="fa-brands fa-facebook-f"></i></a>
            <a href="#"><i class="fa-brands fa-youtube"></i></a>
          </div>
          </div>`;
        document
          .getElementById("collaboratorsBackBtn")
          .addEventListener("click", () => renderCollaboratorsGrid());
      }

      function showProfile(id) {
        const inst = instructors.find((i) => i.id === id);
        if (!inst) return;
        const grid = document.getElementById("instructoresGrid");
        const profile = document.getElementById("instructorProfile");
        grid.style.display = "none";
        profile.style.display = "block";
        profile.style.animation = "none";
        profile.offsetHeight;
        profile.style.animation = "fadeSlideUp 0.5s ease";
        profile.innerHTML = `
          <button class="profile-back-btn" id="profileBackBtn"><i class="fa-solid fa-chevron-left"></i> Volver</button>
          <img src="${inst.avatar}" alt="${inst.name}" class="profile-avatar-lg">
          <div class="profile-name">${inst.name}</div>
          <div class="profile-expertise">${inst.expertise}</div>
          <div class="profile-bio-card">
            <h4>Biografía resumida</h4>
            <p>${inst.bio}</p>
            <h4 style="margin-top:1.2rem;">Biografía Completa</h4>
            <p>${inst.bioFull}</p>
            <div class="profile-social">
            <a href="#"><i class="fa-brands fa-instagram"></i></a>
            <a href="#"><i class="fa-brands fa-linkedin-in"></i></a>
            <a href="#"><i class="fa-brands fa-x-twitter"></i></a>
            <a href="#"><i class="fa-brands fa-facebook-f"></i></a>
            <a href="#"><i class="fa-brands fa-youtube"></i></a>
          </div>
          </div>`;
        document
          .getElementById("profileBackBtn")
          .addEventListener("click", () => renderInstructorsGrid());
      }

      // ── Init ──
      renderInstructorsGrid();
      renderCollaboratorsGrid();

      // Click event delegation for instructor avatars
      document
        .getElementById("instructoresGrid")
        .addEventListener("click", (e) => {
          const avatar = e.target.closest(".instructor-avatar");
          if (avatar && avatar.dataset.id) {
            showProfile(avatar.dataset.id);
          }
        });

      // Click event delegation for Collaborators avatars
      document
        .getElementById("collaboratorsGrid")
        .addEventListener("click", (e) => {
          const avatar = e.target.closest(".instructor-avatar");
          console.log(avatar);
          if (avatar && avatar.dataset.id) {
            showCollaborators(avatar.dataset.id);
          }
        });

      const landingGrid = document.querySelector(".landing-grid");

      // Globe animation on tab change
      document
        .getElementById("landing-tab")
        .addEventListener("hide.bs.tab", () => {
          landingGrid.classList.remove("globe-enter");
          landingGrid.classList.add("globe-exit");
        });

      document
        .getElementById("landing-tab")
        .addEventListener("shown.bs.tab", () => {
          landingGrid.classList.remove("globe-exit");
          landingGrid.classList.add("globe-enter");
        });

      // Reset instructor view when switching tabs
      document
        .getElementById("instructores-tab")
        .addEventListener("shown.bs.tab", () => {
          renderInstructorsGrid();
        });

      // Reset collaborators view when switching tabs
      document
        .getElementById("collaborators-tab")
        .addEventListener("shown.bs.tab", () => {
          renderCollaboratorsGrid();
        });

      // Landing info cards link to tabs
      document.querySelectorAll(".info-card h3").forEach((h3) => {
        h3.style.cursor = "pointer";
        h3.addEventListener("click", () => {
          const text = h3.textContent.trim().toLowerCase();
          console.log(text);
          let tabId = "";
          if (text.includes("instructor")) tabId = "instructores-tab";
          else if (text.includes("leaders")) tabId = "embajadores-tab";
          else if (text.includes("respaldado")) tabId = "respaldado-tab";
          else if (text.includes("partners")) tabId = "convenios-tab";
            else if (text.includes("collaborator")) tabId = "collaborators-tab";
          if (tabId) {
            const tab = new bootstrap.Tab(document.getElementById(tabId));
            tab.show();
          }
        });
      });
    }
  },
};
